// src/pages/CostTracker.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { costAPI } from '../services/api';

const CostTracker = () => {
    const [logs, setLogs] = useState([]);
    const [totalCost, setTotalCost] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchCosts = async () => {
            try {
                setLoading(true);
                const res = await costAPI.getCosts();
                setLogs(res.data.logs);
                setTotalCost(res.data.totalCost);
            } catch (err) {
                setError('Failed to fetch cost data. Please try again later.');
            } finally {
                setLoading(false);
            }
        };

        fetchCosts();
    }, []);

    const formatTimestamp = (isoDate) => {
        return new Date(isoDate).toLocaleString('en-GB', {
            dateStyle: 'medium',
            timeStyle: 'short',
        });
    };

    if (loading) {
        return <div style={{ padding: '20px' }}><h1>Loading cost data...</h1></div>;
    }

    if (error) {
        return <div style={{ padding: '20px' }}>
            <h1 style={{ color: 'red' }}>Error</h1>
            <p>{error}</p>
            <Link to="/dashboard">Back to Dashboard</Link>
        </div>;
    }

    return (
        <div style={{ padding: '20px', maxWidth: '900px', margin: '0 auto' }}>
            <Link to="/dashboard">← Back to Dashboard</Link>
            <h1>Cost Tracker</h1>
            <div style={{ 
                backgroundColor: '#f0f4f8', 
                padding: '15px', 
                borderRadius: '8px', 
                marginBottom: '20px' 
            }}>
                <h2 style={{ margin: 0 }}>Total Estimated Cost: £{totalCost.toFixed(4)}</h2>
            </div>

            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr style={{ backgroundColor: '#eee' }}>
                        <th style={tableHeaderStyle}>Date & Time</th>
                        <th style={tableHeaderStyle}>API Call</th>
                        <th style={tableHeaderStyle}>Model</th>
                        <th style={tableHeaderStyle}>Usage (Tokens)</th>
                        <th style={tableHeaderStyle}>Cost (GBP)</th>
                        <th style={tableHeaderStyle}>Context</th>
                    </tr>
                </thead>
                <tbody>
                    {logs.length === 0 ? (
                        <tr>
                            <td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>
                                No cost data logged yet.
                            </td>
                        </tr>
                    ) : (
                        logs.map(log => (
                            <tr key={log._id} style={{ borderBottom: '1px solid #ddd' }}>
                                <td style={tableCellStyle}>{formatTimestamp(log.createdAt)}</td>
                                <td style={tableCellStyle}>{log.apiCallType}</td>
                                <td style={tableCellStyle}>{log.model}</td>
                                <td style={tableCellStyle}>{log.tokenUsage || 'N/A'}</td>
                                <td style={tableCellStyle}>£{log.cost.toFixed(6)}</td>
                                <td style={tableCellStyle}>
                                    {log.lessonPlan ? `Plan: ${log.lessonPlan.title}` : 'N/A'}
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
};

// Simple inline styles for the table
const tableHeaderStyle = {
    padding: '12px',
    textAlign: 'left',
    borderBottom: '2px solid #ccc',
};

const tableCellStyle = {
    padding: '10px 12px',
    verticalAlign: 'top',
};

export default CostTracker;